import type { ConversationLogDto } from '@shared/services/conversationApiService/apiService';
import type { ToolCallData } from '@shared/services/conversationApiService/types';

import { isRecord } from './isRecord';

export type ValidatedConversationLogDto = ConversationLogDto &
  ({ type: 'text' } | { type: 'tool_call'; toolCall: ToolCallData });

export { isRecord };

export const isToolCallData = (value: unknown): value is ToolCallData => {
  if (!isRecord(value) || !isRecord(value.function_call)) return false;

  const functionCall = value.function_call;
  const output = value.function_call_output;

  return (
    typeof functionCall.name === 'string' &&
    typeof functionCall.arguments === 'string' &&
    typeof functionCall.call_id === 'string' &&
    functionCall.call_id.length > 0 &&
    (output === null ||
      (isRecord(output) &&
        typeof output.output === 'string' &&
        typeof output.is_error === 'boolean')) &&
    (value.source === 'local' || value.source === 'mcp' || value.source === 'unknown') &&
    (value.lifecycleStatus === 'done' ||
      value.lifecycleStatus === 'error' ||
      value.lifecycleStatus === 'cancelled') &&
    typeof value.startedAt === 'string' &&
    typeof value.endedAt === 'string'
  );
};

export const isValidConversationLog = (
  message: ConversationLogDto,
): message is ValidatedConversationLogDto =>
  message.type !== 'tool_call' || isToolCallData(message.toolCall);
